import { GraphQLError } from 'graphql';
import { CheckinSegmentFragment } from '@websky/graphql';
import { SegmentsFailedBoardingPasses } from './types';

export const isOnlyAirportCheckinStatus = (status: string) => /^OnlyAirportCheckIn$/i.test(status);

export const hasSegmentBoardingPass = (
	segment: CheckinSegmentFragment,
	segmentsFailedBoardingPasses: SegmentsFailedBoardingPasses
) =>
	segment.checkinInfo.airportHasDcs &&
	segment.checkinInfo.hasBoardingPasses !== false &&
	!segmentsFailedBoardingPasses.has(segment.id);

export const isDifferentCurrenciesError = (error: GraphQLError) => {
	const differentCurrenciesError =
		'The check in order cannot be processed because one of the tickets is issued in a currency different from the currency of the pass tickets in the check order';

	return (
		error.message.includes(differentCurrenciesError) ||
		(error as any).debugMessage?.includes(differentCurrenciesError)
	);
};
